import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { border, color, font } = baseVariables;

export const StyledTable = styled.table`
  width: 100%;
  font-weight: ${font.fontWeightMedium};
  thead {
    tr {
      text-align: left;
      th {
        vertical-align: baseline;
        padding: ${toRem(8)} ${toRem(10)};
        border-bottom: ${toRem(1)} solid ${color.alert20};
      }
    }
  }
  tbody {
    tr {
      border-bottom: ${toRem(1)} solid ${color.neutral20};
      &:last-child {
        border-bottom: none;
      }
      td {
        vertical-align: baseline;
        width: auto;
        padding: ${toRem(8)} ${toRem(10)};
        span {
          font-weight: ${font.fontWeightRegular};
        }
      }
    }
  }
`;

export const StyledEventBookingDetails = styled.div`
  width: 100%;
  .shell {
    border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
    background-color: ${color.base20};
    box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);
  }
  .event-bookings {
    padding-top: ${toRem(22)};
    border-top: ${toRem(1)} solid ${color.alert20};
    tr:nth-last-of-type(2) {
      border-bottom: ${toRem(1)} solid ${color.alert20} !important;
    }
  }
  .group-rates {
    padding-top: ${toRem(22)};
    border-top: ${toRem(1)} solid ${color.alert20};
  }
`;
